<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="swatchMainCategory({ mainCategoryId: '', categoryName: '全部' })"
              :class="{ 'selected': mainCategoryProductInfo.conditions.mainCategoryId === '' }">
              {{ $t('common.all') }}
            </li>
            <li v-for="(item, index) in mainCategoryProductInfo.mainCategorys"
              :key="index" @click="swatchMainCategory(item)"
              :class="{ 'selected': mainCategoryProductInfo.conditions.mainCategoryId == item.mainCategoryId }">
              {{ item.categoryName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('mainCategoryProduct.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input :placeholder="$t('mainCategoryProduct.inputName')"
                v-model="mainCategoryProductInfo.conditions.productName">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="_queryMainCategoryProductMethod()">
                {{ $t('mainCategoryProduct.query') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('mainCategoryProduct.specialProduct') }}</span>
            <el-button type="primary" size="small" style="float: right;" @click="_openAddMainCategoryProductModal()">
              {{ $t('mainCategoryProduct.add') }}
            </el-button>
          </div>
          <el-table :data="mainCategoryProductInfo.mainCategoryProducts" style="width: 100%">
            <el-table-column prop="categoryName" :label="$t('mainCategoryProduct.category')" align="center">
            </el-table-column>
            <el-table-column prop="productId" :label="$t('mainCategoryProduct.code')" align="center">
            </el-table-column>
            <el-table-column prop="productName" :label="$t('mainCategoryProduct.name')" align="center">
            </el-table-column>
            <el-table-column prop="startTime" :label="$t('mainCategoryProduct.startTime')" align="center">
            </el-table-column>
            <el-table-column prop="endTime" :label="$t('mainCategoryProduct.endTime')" align="center">
            </el-table-column>
            <el-table-column prop="seq" :label="$t('mainCategoryProduct.sort')" align="center">
            </el-table-column>
            <el-table-column :label="$t('mainCategoryProduct.operation')" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="_openEditMainCategoryProductModel(scope.row)">
                  {{ $t('mainCategoryProduct.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="_openDeleteMainCategoryProductModel(scope.row)">
                  {{ $t('mainCategoryProduct.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="mainCategoryProductInfo.conditions.page"
            :page-size="mainCategoryProductInfo.conditions.row" layout="total, prev, pager, next"
            :total="mainCategoryProductInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-main-category-product ref="addMainCategoryProduct" @refresh="_listMainCategoryProducts"></add-main-category-product>
    <edit-main-category-product ref="editMainCategoryProduct" @refresh="_listMainCategoryProducts"></edit-main-category-product>
    <delete-main-category-product ref="deleteMainCategoryProduct" @refresh="_listMainCategoryProducts"></delete-main-category-product>
  </div>
</template>

<script>
import { queryMainCategoryProduct, queryMainCategory } from '@/api/admin/mainCategoryProduct/mainCategoryProductApi'
import AddMainCategoryProduct from '@/components/admin/addMainCategoryProduct/addMainCategoryProduct'
import EditMainCategoryProduct from '@/components/admin/editMainCategoryProduct/editMainCategoryProduct'
import DeleteMainCategoryProduct from '@/components/admin/deleteMainCategoryProduct/deleteMainCategoryProduct'

export default {
  name: 'MainCategoryProduct',
  components: {
    AddMainCategoryProduct,
    EditMainCategoryProduct,
    DeleteMainCategoryProduct
  },
  data() {
    return {
      mainCategoryProductInfo: {
        mainCategoryProducts: [],
        total: 0,
        records: 1,
        moreCondition: false,
        mcProductId: '',
        mainCategorys: [],
        conditions: {
          page: 1,
          row: 10,
          mainCategoryId: '',
          productId: '',
          productName: '',
          state: ''
        }
      }
    }
  },
  created() {
    this._listMainCategoryProducts()
    this._listMainCategorys()
  },
  methods: {
    handleCurrentChange(val) {
      this.mainCategoryProductInfo.conditions.page = val
      this._listMainCategoryProducts()
    },
    async _listMainCategoryProducts() {
      try {
        const res = await queryMainCategoryProduct(this.mainCategoryProductInfo.conditions)
        this.mainCategoryProductInfo.total = res.total
        this.mainCategoryProductInfo.records = res.records
        this.mainCategoryProductInfo.mainCategoryProducts = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _listMainCategorys() {
      try {
        const res = await queryMainCategory({ page: 1, row: 100 })
        this.mainCategoryProductInfo.mainCategorys = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAddMainCategoryProductModal() {
      this.$refs.addMainCategoryProduct.open()
    },
    _openEditMainCategoryProductModel(row) {
      this.$refs.editMainCategoryProduct.open(row)
    },
    _openDeleteMainCategoryProductModel(row) {
      this.$refs.deleteMainCategoryProduct.open(row)
    },
    _queryMainCategoryProductMethod() {
      this.mainCategoryProductInfo.conditions.page = 1
      this._listMainCategoryProducts()
    },
    swatchMainCategory(category) {
      this.mainCategoryProductInfo.conditions.mainCategoryId = category.mainCategoryId
      this._listMainCategoryProducts()
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

/* 使用全局 list-selector 样式，无需自定义样式 */
</style>